
<script>
	import listBase from '@_system/components/base/list.vue'
	import editIndex from './edit/index.vue'
	export default {
		extends: listBase,
		name: 'logistictraceIndex',
		props: {

		},
		render(h) {
			this.$slots.plug = [
				<edit-index ref="logistictraceEdit" row={this.currentRow} onSuccess={this.editSuccess} />,		
			]
			return listBase.render.call(this, h)
		},
		data() {
			return {
				moduleName: 'logistictrace',
				windowName: '退回物流跟踪',
				windowType: 'modal',
				currentRow:null
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},
		methods: {
			editSuccess(){
				this.customreload()
			},
			editformShow(row) {
				this.currentRow = row
				this.$refs.logistictraceEdit.modal_show()
			},
		},
		components: {
			editIndex
		}
	}
</script>
